﻿document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".bl-lead form[data-section-id], .rs-card form[data-section-id]").forEach(function (form) {
        form.addEventListener("submit", async function (e) {
            e.preventDefault();

            var sectionId = form.getAttribute("data-section-id");
            var msgBox = document.querySelector('[data-lead-message="' + sectionId + '"]');
            var btn = form.querySelector('button[type="submit"]');
            var originalBtnText = btn ? btn.innerHTML : "";

            if (btn) {
                btn.disabled = true;
                btn.innerHTML = "Sending\u2026";
            }
            if (msgBox) msgBox.innerHTML = "";

            try {
                var res = await fetch(form.action, {
                    method: "POST",
                    headers: { "X-Requested-With": "XMLHttpRequest" },
                    body: new FormData(form)
                });

                var data = await res.json();

                if (msgBox) {
                    if (data.success) {
                        msgBox.innerHTML =
                            '<div class="alert alert-success mt-3 mb-0" role="alert">' +
                            (data.successMessage || "The document has been emailed to you.") +
                            "</div>";
                        form.reset();

                        // Reset this form's Turnstile widget so a fresh token is issued next time
                        if (window.turnstile) {
                            var tsEl = form.querySelector(".cf-turnstile");
                            if (tsEl) window.turnstile.reset(tsEl);
                        }
                    } else {
                        msgBox.innerHTML =
                            '<div class="alert alert-danger mt-3 mb-0" role="alert">' +
                            (data.errorMessage || "Something went wrong. Please try again.") +
                            "</div>";
                    }
                }
            } catch (err) {
                if (msgBox) {
                    msgBox.innerHTML =
                        '<div class="alert alert-danger mt-3 mb-0" role="alert">' +
                        "We couldn't send the email right now. Please try again later." +
                        "</div>";
                }
            } finally {
                if (btn) {
                    btn.disabled = false;
                    btn.innerHTML = originalBtnText;
                }
            }
        });
    });
});